import { BannerTiny } from 'components/banner-tiny/banner-tiny';
import { t } from 'i18next';
import { Trans } from 'react-i18next';

import {
  ARTICLE_ALLOWED_MEASURES,
  ARTICLE_AVAILABLE_CATEGORIES,
  ARTICLE_INVOICE_REQUEST,
} from '../../../utils/external-urls';
import { UNQUALIFIED_SEGMENTS_KEY } from '../constants';
import { UnqualifedDescription } from '../pages/unqualified/unqualified-page.style';

const unqualifiedItems = [
  {
    key: 'has_valid_state',
    title: t`outside the coverage area`,
    link: '',
    labelLink: '',
    description: (
      // TODO: Get states from leads
      <UnqualifedDescription>
        <p>
          <Trans i18nKey="unqualifiedStates">
            At this moment, we only serve companies in the states of
            <strong> SP, RJ, ES, MG, PR, SC, RS and BA</strong>. While we work to serve your region,
            we recommend that you advertise on marketplaces using Tiny, which is part of the Olist
            Group.
          </Trans>
        </p>
        <br />
        <p>{t`Tiny is a management system with integration hub capabilities. With it, you can:`}</p>
        <br />

        <ul>
          <li>
            {t`Advertise products on dozens of marketplaces, such as Mercado Livre, Shopee, Amazon, Americanas and Aliexpress`}
          </li>
          <li>{t`Control products, stock, prices and orders in a few clicks`}</li>
          <li>{t`Issue invoices automatically`}</li>
          <li>{t`Reduce operational errors and gain efficiency`}</li>
        </ul>
        <BannerTiny />
      </UnqualifedDescription>
    ),
    icon: 'pin-outline',
  },
  {
    key: UNQUALIFIED_SEGMENTS_KEY,
    title: t`category unavailable`,
    link: ARTICLE_AVAILABLE_CATEGORIES,
    description: (
      <Trans i18nKey="unqualifiedCategories">
        some categories selected by you are not currently accepted by <b>olist</b>, but it is
        possible to operate normally with the allowed categories. Check out which ones:
      </Trans>
    ),
    icon: 'list-alt',
  },
  {
    key: 'has_purchase_invoice',
    title: t`purchase tax note`,
    link: ARTICLE_INVOICE_REQUEST,
    description: (
      <UnqualifedDescription>{t`the purchase invoice is requested to guarantee the quality of the product to the final consumer.`}</UnqualifedDescription>
    ),
    icon: 'document-alt',
  },
  {
    key: 'has_bank_account_associated_cnpj',
    title: t`pj account associated with cnpj`,
    link: 'https://lp.cora.com.br/parceiros/olist/',
    labelLink: t`know Cora bank`,
    description: (
      <UnqualifedDescription>
        <Trans i18nKey="unqualifiedBankAccount">
          the transfer depends on the company having an exclusive bank account for the registered
          CNPJ. Meet the cora bank, <b>olist</b> partner company that helps you create a pj account{' '}
          without fees, without bureaucracy and simple to use.
        </Trans>
      </UnqualifedDescription>
    ),
    icon: 'bank-alt',
  },
  {
    key: 'has_nfe_xml',
    title: t`xml invoice`,
    link: 'https://tiny.com.br/nota-fiscal-tiny-olistdescnf?utm_source=sup&utm_medium=fluxo&utm_campaign=descartes-nf',
    labelLink: t`know Tiny`,
    description: (
      <UnqualifedDescription>
        <Trans i18nKey="unqualifiedNfe">
          Issuing NF-e in XML format is essential to invoice your sales on marketplaces. With Tiny,
          <b>
            you issue your notes for free for 30 days and get 3 more months with a 50% discount on
            the monthly fee
          </b>
          .
        </Trans>
      </UnqualifedDescription>
    ),
    icon: 'computer-alt',
  },
  {
    key: 'respect_correios_max_dimensions',
    title: t`post office measurements`,
    link: ARTICLE_ALLOWED_MEASURES,
    labelLink: t`see more about allowed measures`,
    description: (
      <UnqualifedDescription>
        {' '}
        {t`the products can only be sold if they are below the measurements: 100cm x 100cm x 100cm, 30kg.`}
      </UnqualifedDescription>
    ),
    icon: 'truck-alt',
  },
  {
    key: 'has_erp',
    title: t`HUB or ERP (integrated management system)`,
    link: 'https://tiny.com.br/integracoes?utm_source=sup&utm_medium=fluxo&utm_campaign=descartes-integracoes',
    labelLink: t`know Tiny`,
    description: (
      <UnqualifedDescription>
        {t(
          'To ensure greater agility and operational ease, your company Hub or ERP must be integrated with the Olist system. We present an opportunity to learn about our complete ERP system. With Olist Tiny you will have personalized solutions for your segment.'
        )}
      </UnqualifedDescription>
    ),
  },
];

export default unqualifiedItems;
